import React from "react";
import Select from 'react-select';

const formatSize = (bytes) => {
  if (!bytes && bytes !== 0) return '-';
  const units = ['B','KB','MB','GB','TB'];
  let size = Math.max(bytes, 0);
  let idx = 0;
  while (size >= 1024 && idx < units.length - 1) {
    size /= 1024;
    idx += 1;
  }
  return `${size.toFixed(size < 10 && idx > 0 ? 1 : 0)} ${units[idx]}`;
};

export function ContactCreateForm({
  formData,
  setFormData,
  contactTypes = [],
  onManageTypes,
  allContacts = [],
  labelsList = [],
  onManageLabels,
  pendingPhotos = [],
  onOpenPhotoModal = () => {},
  onRemovePhoto = null,
}) {

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const typeOptions = contactTypes.map((t) => ({ value: t._id, label: t.contactTypeName }));
  const selectedTypes = (Array.isArray(formData.contactType) ? formData.contactType : (formData.contactType ? [formData.contactType] : []))
    .map(id => typeOptions.find(o => o.value === id))
    .filter(Boolean);

  const labelOptions = labelsList.map((l) => ({ value: l._id, label: l.labelName }));
  const selectedLabels = (Array.isArray(formData.labels) ? formData.labels : [])
    .map(id => labelOptions.find(o => o.value === id))
    .filter(Boolean);

  const contactOptions = allContacts
    .filter(c => !formData._id || String(c._id) !== String(formData._id))
    .map(c => ({
      value: c._id,
      label: c.contactName || c.contactPhone || c.contactEmail || String(c._id).slice(0,6)
    }));
  const selectedReferredBy = typeof formData.referredBy === 'string'
    ? contactOptions.find(o => o.value === formData.referredBy) || null
    : (contactOptions.find(o => o.value === (formData.referredBy || '')) || null);

  return (
    <form>
      {/* Contact Type Field */}
      <div className="mb-3">
        <div className="d-flex justify-content-between align-items-center">
          <label htmlFor="contactType" className="form-label mb-0">Contact Type</label>
          {onManageTypes && (
            <button type="button" className="btn btn-link p-0" onClick={onManageTypes}>Manage types</button>
          )}
        </div>
        <Select
          inputId="contactType"
          options={typeOptions}
          value={selectedTypes}
          onChange={(opts)=> setFormData(prev=> ({...prev, contactType: Array.isArray(opts) ? opts.map(o=>o.value) : []}))}
          placeholder="Select contact types"
          isMulti
        />
        <div className="form-text">Choose one or more contact types.</div>
      </div>
      <div className="mb-3">
        <div className="d-flex justify-content-between align-items-center">
          <label className="form-label mb-0">Photos</label>
          <button
            type="button"
            className="btn btn-sm btn-outline-primary"
            onClick={onOpenPhotoModal}
          >
            Select Photos
          </button>
        </div>
        {pendingPhotos.length === 0 ? (
          <div className="text-muted small">No photos selected.</div>
        ) : (
          <ul className="list-group list-group-flush small border rounded">
            {pendingPhotos.map((file, idx) => (
              <li
                key={`${file.name}-${file.size}-${file.lastModified}-${idx}`}
                className="list-group-item d-flex align-items-center justify-content-between py-2"
              >
                <div className="me-2 text-truncate">
                  <div className="fw-medium text-truncate" title={file.name}>{file.name}</div>
                  <div className="text-muted">{formatSize(file.size)}</div>
                </div>
                {onRemovePhoto && (
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={()=> onRemovePhoto(idx)}
                  >
                    Remove
                  </button>
                )}
              </li>
            ))}
          </ul>
        )}
        <div className="form-text">Selected photos upload after saving the contact.</div>
      </div>

      {/* Labels (multi-select) */}
      {/* <div className="mb-3">
        <div className="d-flex justify-content-between align-items-center">
          <label htmlFor="labels" className="form-label mb-0">Labels</label>
          {onManageLabels && (
            <button type="button" className="btn btn-link p-0" onClick={onManageLabels}>Manage labels</button>
          )}
        </div>
        <select
          id="labels"
          name="labels"
          className="form-select"
          multiple
          value={Array.isArray(formData.labels) ? formData.labels : []}
          onChange={(e) => {
            const options = Array.from(e.target.selectedOptions).map(o=>o.value);
            setFormData(prev => ({...prev, labels: options }));
          }}
        >
          {labelsList.map((l) => (
            <option key={l._id} value={l._id}>{l.labelName}</option>
          ))}
        </select>
        <div className="form-text">Hold Ctrl/Cmd to select multiple labels.</div>
      </div> */}
      {/* Name Field */}
      <div className="mb-3">
        <label htmlFor="name" className="form-label">
          Full Name
        </label>
        <input
          type="text"
          className="form-control"
          id="name"
          name="contactName"
          value={formData.contactName}
          onChange={handleChange}
          placeholder="Enter full name"
          required
        />
      </div>

      {/* Email Address Field */}
      <div className="mb-3">
        <label htmlFor="email" className="form-label">
          Email
        </label>
        <input
          type="email"
          className="form-control"
          id="email"
          name="contactEmail"
          value={formData.contactEmail}
          onChange={handleChange}
          placeholder="Enter contact email"
          required
        />
      </div>

      {/* Phone Number Field */}
      <div className="mb-3">
        <label htmlFor="phone" className="form-label">
          Phone
        </label>
        <input
          type="tel"
          className="form-control"
          id="phone"
          name="contactPhone"
          value={formData.contactPhone}
          onChange={handleChange}
          placeholder="Enter phone number"
          required
        />
      </div>

      {/* Labels (multi-select) */}
      <div className="mb-3">
        <div className="d-flex justify-content-between align-items-center">
          <label htmlFor="labels" className="form-label mb-0">Labels</label>
          {onManageLabels && (
            <button type="button" className="btn btn-link p-0" onClick={onManageLabels}>Manage labels</button>
          )}
        </div>
        <Select
          inputId="labels"
          options={labelOptions}
          value={selectedLabels}
          onChange={(opts)=> setFormData(prev=> ({...prev, labels: Array.isArray(opts) ? opts.map(o=>o.value) : []}))}
          isMulti
          placeholder="Select labels"
        />
        <div className="form-text">Select multiple labels if applicable.</div>
      </div>

      {/* Referred By Field */}
      <div className="mb-0">
        <label htmlFor="referredBy" className="form-label">Referred By</label>
        <Select
          inputId="referredBy"
          options={contactOptions}
          value={selectedReferredBy}
          onChange={(opt)=> setFormData(prev=> ({...prev, referredBy: opt?.value || null}))}
          isClearable
          placeholder="None"
        />
        <div className="form-text">Select the contact who referred this lead.</div>
        <div className="border rounded p-2 mt-2">
          <div className="fw-semibold small mb-2">Or create a new referrer</div>
          <div className="row g-2">
            <div className="col-md-6">
              <label className="form-label mb-1" htmlFor="referredByName">Referrer Name</label>
              <input
                id="referredByName"
                name="referredByName"
                className="form-control"
                value={formData.referredByName || ''}
                onChange={handleChange}
                placeholder="Optional name"
              />
            </div>
            <div className="col-md-6">
              <label className="form-label mb-1" htmlFor="referredByPhone">Referrer Phone</label>
              <input
                id="referredByPhone"
                name="referredByPhone"
                className="form-control"
                value={formData.referredByPhone || ''}
                onChange={handleChange}
                placeholder="Enter phone to create new referrer"
              />
            </div>
          </div>
          <div className="form-text">If you provide a phone number and leave the selector empty, a new contact will be created and linked.</div>
        </div>
      </div>

      {/* Note (optional) */}
      <div className="mt-3">
        <label htmlFor="initialNote" className="form-label">Note (optional)</label>
        <textarea
          id="initialNote"
          name="note"
          rows={3}
          className="form-control"
          placeholder="Add a note for this contact..."
          value={formData.note || ''}
          onChange={handleChange}
        />
      </div>
    </form>
  );
}
